import { useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [buttonText, setButtonText] = useState("Login In");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  function handleSignIn(e) {
    e.preventDefault(); // stop form refresh

    setButtonText("Please wait...");

    if (email === "chandan@tristar.com" && password === "Password@123") {
    // if (true) {
      navigate("/reportsSubmitted");
    } else {
      setError("Wrong email or password");
      setButtonText("Login In");
    }
  }

return (
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12 col-sm-10 col-md-6 col-lg-4">
        <form
          className="mt-5 mb-5 border border-primary border-2 rounded-3 p-4 p-md-5"
          onSubmit={handleSignIn}
        >
          <div className="mb-3">
            <label className="form-label">Email address</label>
            <input
              type="email"
              className="form-control"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && <p className="text-danger">{error}</p>}

          <button type="submit" className="btn btn-primary w-100">
            {buttonText}
          </button>
        </form>
      </div>
    </div>
  </div>
);

}

export default AdminLogin;
